import type { ComponentProps } from "react"
import { cn } from "cn"

export type DateButtonProps = ComponentProps<"button"> & {
  /** Figma-Achse „Variante": `prominent` (Heading/lg, 36px hoch) oder `default` (Body/md/semibold, 32px hoch). */
  variant?: "prominent" | "default"
  /** Figma-State „hover on grey" — dunklere Hover-Fläche für Einsatz auf grauem Hintergrund. */
  onGrey?: boolean
}

/**
 * Figma-Component-Set „Date Button" (node 2134:2160): klickbares Datums-Label,
 * z. B. als Popover-Trigger im `DateNavigator`. Ohne Rahmen/Fläche im
 * Ruhezustand, nur beim Hover erscheint die Pill-Fläche.
 */
function DateButton({
  className,
  variant = "prominent",
  onGrey = false,
  type = "button",
  ...props
}: DateButtonProps) {
  return (
    <button
      type={type}
      data-slot="date-button"
      data-variant={variant}
      className={cn(
        "inline-flex shrink-0 cursor-pointer items-center justify-center gap-2 rounded-full px-3 whitespace-nowrap text-labels-primary transition-colors outline-none focus-visible:ring-2 focus-visible:ring-neutrals-v2-600 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:text-neutrals-v2-600 disabled:hover:bg-transparent",
        variant === "prominent"
          ? "h-9 py-0.5 text-2xl leading-8 font-[650]"
          : "h-8 py-1.5 text-sm leading-5 font-semibold",
        onGrey ? "hover:bg-neutrals-v2-300" : "hover:bg-neutrals-v2-200",
        className
      )}
      {...props}
    />
  )
}
DateButton.displayName = "DateButton"

export { DateButton }
